<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form :model="table.where" label-width="77px" class="ele-form-search"
                @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                <el-row :gutter="15">
                    <el-col :md="6" :sm="12">
                        <el-form-item label="表名称:">
                            <el-input v-model="table.where.name" placeholder="请输入表名称" clearable />
                        </el-form-item>
                    </el-col>
                    <el-col :md="6" :sm="12">
                        <el-form-item label="表描述:">
                            <el-input v-model="table.where.comment" placeholder="请输入表描述" clearable />
                        </el-form-item>
                    </el-col>
                    <el-col :md="9" :sm="12">
                        <div class="ele-form-actions">
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 操作按钮 -->
            <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">
                    添加
                </el-button>
            </div>
            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 260px)"
                highlight-current-row>
                <template slot-scope="{index}">
                    <el-table-column type="selection" width="45" align="center" fixed="left" />
                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                        show-overflow-tooltip />
                    <el-table-column prop="name" label="业务表名称" show-overflow-tooltip align="center" min-width="150" />
                    <el-table-column prop="comment" label="表描述" show-overflow-tooltip align="center" min-width="120" />
                    <el-table-column prop="engine" label="表引擎" show-overflow-tooltip align="center" min-width="150" />
                    <el-table-column prop="version" label="版本号" show-overflow-tooltip align="center" min-width="120" />
                    <el-table-column prop="collation" label="编码" show-overflow-tooltip align="center" min-width="150" />
                    <el-table-column prop="rows" label="记录总数" show-overflow-tooltip align="center" min-width="200" />
                    <el-table-column prop="data_length" label="数据大小" sortable="custom" show-overflow-tooltip
                        align="center" min-width="120" />
                    <el-table-column prop="auto_increment" label="自增索引" show-overflow-tooltip align="center"
                        min-width="120" />
                    <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.create_time | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.update_time | toDateString }}</template>
                    </el-table-column>
                    <!-- <el-table-column label="操作" width="150px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-popconfirm title="确定要一键生成当前表的模块吗？" @confirm="generate(row)" class="ele-action">
                                <el-link slot="reference" icon="el-icon-copy-document" type="success"
                                    :underline="false">一键生成模块</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column> -->
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog title="一键生成" :visible.sync="showEdit" width="900px"
            @closed="closeShow" custom-class="ele-dialog-form" :lock-scroll="false" :close-on-click-modal="false">
            <div class="ikz-top-menu">
                <el-radio-group v-model="mode" style="margin-bottom: 30px;">
                    <el-radio-button label="1">单模块生成</el-radio-button>
                    <el-radio-button label="2">多模块生成</el-radio-button>
                </el-radio-group>
            </div>
            <div v-if="mode == 1">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px" >
                    <h3 style="margin:15px 0px;">菜单设置</h3>
                    <el-form-item label="选择菜单:" prop="title">
                        <el-select v-model="editForm.menu_id" filterable placeholder="请选择">
                            <el-option v-for="item in menu_data" :key="item.title" :label="item.title" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <h3 style="margin:15px 0px;">关联模式</h3>
                    <el-form-item label="关联模式:" prop="title">
                        <el-switch v-model="editForm.isrelation" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <h3 style="margin:15px 0px;">页面设置</h3>
                    <el-form-item label="选择模式:" prop="title">
                        <el-radio-group v-model="editForm.pagemode">
                            <el-radio :label="1">列表模式</el-radio>
                            <el-radio :label="2">配置模式</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <h3 style="margin:15px 0px;">主表设置</h3>
                    <el-form-item label="主表选择:" prop="title">
                        <el-select v-model="editForm.name_index" @change="nameChange($event,'')" filterable placeholder="请选择">
                            <el-option v-for="(item,index) in allSqlList" :key="item.name" :label="item.name"
                                :value="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div style="margin:15px 0px;" v-if="editForm.isrelation">
                        <h3>关联表设置</h3>
                        <div v-for="(item,index) in editForm.relation" :key="index" style="margin:15px 0px;">
                            <el-row :gutter="24">
                                <el-col :md="4">
                                    <div>
                                        <div>
                                            关联表:
                                        </div>
                                        <el-select v-model="editForm.relation[index].relation"
                                            @change="relationChange(index,'')" filterable placeholder="请选择">
                                            <el-option v-for="item in allSqlList" :key="item.name" :label="item.name"
                                                :value="item.name">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                
                                <el-col :md="4">
                                    <div>
                                        <div>
                                            请选择关联类型:
                                        </div>
                                        <el-select v-model="editForm.relation[index].relationmode" filterable
                                            placeholder="请选择">
                                            <el-option v-for="item in relationmodeArray"
                                                :key="item.title" :label="item.title" :value="item.title">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                <el-col :md="4">
                                    <div>
                                        <div>
                                            关联外键:
                                        </div>
                                        <el-select v-model="editForm.relation[index].relationforeignkey" filterable
                                            placeholder="请选择">
                                            <el-option v-for="item in editForm.relation[index].relationforeignkeyArray"
                                                :key="item.columnName" :label="item.columnName" :value="item.columnName">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                <el-col :md="4">
                                    <div>
                                        <div>
                                            关联主键:
                                        </div>
                                        <el-select v-model="editForm.relation[index].relationprimarykey" filterable
                                            placeholder="请选择">
                                            <el-option v-for="item in relationprimarykeyArray" :key="item.columnName"
                                                :label="item.columnName" :value="item.columnName">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                <el-col :md="4">
                                    <div>
                                        <div>
                                            显示字段:
                                        </div>
                                        <el-select v-model="editForm.relation[index].relationfields" multiple filterable
                                            placeholder="请选择">
                                            <el-option v-for="item in editForm.relation[index].relationforeignkeyArray"
                                                :key="item.columnName" :label="item.columnName" :value="item.columnName">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                <el-col :md="4">
                                    <div>
                                        <div>
                                            操作:
                                        </div>
                                        <el-button type="danger" @click="delRelation(index,'')">移除</el-button>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <el-button style="margin:15px 0px;" type="info" plain @click="addRelation('')">追加关联表</el-button>
                    </div>
                   
                </el-form>
            </div>
            <div v-else>
                <el-form :model="editFormList" ref="editForm" :rules="editRules" label-width="100px" >
                <h3 style="margin:15px 0px;">菜单设置</h3>
                <el-form-item label="选择菜单:" prop="title">
                    <el-select v-model="editFormList.menu_id" filterable placeholder="请选择">
                        <el-option v-for="item in menu_data" :key="item.title" :label="item.title" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                
                <el-tabs v-model="editableTabsValue" type="card" editable @edit="handleTabsEdit">
                    <el-tab-pane :key="indexs" v-for="(items, indexs) in editFormList.list" :label="items.menu_title"
                        :name="items.menu_title">
                            
                            <h3 style="margin:15px 0px;">关联模式</h3>
                            <el-form-item label="关联模式:" prop="title">
                                <el-switch v-model="items.isrelation" active-color="#13ce66" inactive-color="#ff4949">
                                </el-switch>
                            </el-form-item>
                            <h3 style="margin:15px 0px;">页面设置</h3>
                            <el-form-item label="选择模式:" prop="title">
                                <el-radio-group v-model="items.pagemode">
                                    <el-radio :label="1">列表模式</el-radio>
                                    <el-radio :label="2">配置模式</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <h3 style="margin:15px 0px;">主表设置</h3>
                            <el-form-item label="主表选择:" prop="title">
                                <el-select v-model="items.name_index" @change="nameChange($event,indexs)" filterable placeholder="请选择">
                                    <el-option v-for="(item,index) in allSqlList" :key="item.name" :label="item.name"
                                        :value="index">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <div style="margin:15px 0px;" v-if="items.isrelation">
                                <h3>关联表设置</h3>
                                <div v-for="(item,index) in items.relation" :key="index" style="margin:15px 0px;">
                                    <el-row :gutter="24">
                                        <el-col :md="4">
                                            <div>
                                                <div>
                                                    关联表:
                                                </div>
                                                <el-select v-model="items.relation[index].relation"
                                                    @change="relationChange(index,indexs)" filterable placeholder="请选择">
                                                    <el-option v-for="item in allSqlList" :key="item.name" :label="item.name"
                                                        :value="item.name">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </el-col>
                                        <el-col :md="4">
                                            <div>
                                                <div>
                                                    请选择关联类型:
                                                </div>
                                                <el-select v-model="items.relation[index].relationmode" filterable
                                                    placeholder="请选择">
                                                    <el-option v-for="item in relationmodeArray"
                                                        :key="item.title" :label="item.title" :value="item.title">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </el-col>
                                        <el-col :md="4">
                                            <div>
                                                <div>
                                                    关联外键:
                                                </div>
                                                <el-select v-model="items.relation[index].relationforeignkey" filterable
                                                    placeholder="请选择">
                                                    <el-option v-for="item in items.relation[index].relationforeignkeyArray"
                                                        :key="item.columnName" :label="item.columnName" :value="item.columnName">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </el-col>
                                        <el-col :md="4">
                                            <div>
                                                <div>
                                                    关联主键:
                                                </div>
                                                <el-select v-model="items.relation[index].relationprimarykey" filterable
                                                    placeholder="请选择">
                                                    <el-option v-for="item in relationprimarykeyArray" :key="item.columnName"
                                                        :label="item.columnName" :value="item.columnName">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </el-col>
                                        <el-col :md="4">
                                            <div>
                                                <div>
                                                    显示字段:
                                                </div>
                                                <el-select v-model="items.relation[index].relationfields" multiple  filterable
                                                    placeholder="请选择">
                                                    <el-option v-for="item in items.relation[index].relationforeignkeyArray"
                                                        :key="item.columnName" :label="item.columnName" :value="item.columnName">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </el-col>
                                        <el-col :md="4">
                                            <div>
                                                <div>
                                                    操作:
                                                </div>
                                                <el-button type="danger" @click="delRelation(index,indexs)">移除</el-button>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                                <el-button style="margin:15px 0px;" type="info" plain @click="addRelation(indexs)">追加关联表</el-button>
                            </div>
                    </el-tab-pane>
                </el-tabs>
                </el-form>
            </div>
            <div slot="footer">
                <el-button @click="closeShow">取消</el-button>
                <el-button type="primary" @click="generate">一键生成</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";
    export default {
        name: "Generate",
        data() {
            return {
                visible: false,
                table: {
                    url: '/generate/generate/index',
                    where: {}
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                tableId: '',
                editForm: {
                    relation: [
                    ],
                    pagemode: 1,
                   
                },
                editFormList: {
                    list:[
                        {
                            menu_title:'数据1',
                            relation: [],
                            pagemode: 1,
                        }
                    ]
                    },
                editRules: { // 表单验证规则

                },
                allSqlList: {

                },
                menu_data: [], //菜单合集
                relationprimarykeyArray: [], //主键
                mode:1,//数据模式
                /* */
                editableTabsValue: '数据1',
                editableTabs: [{
                    title: 'Tab 1',
                    name: '1',
                }, {
                    title: 'Tab 2',
                    name: '2',
                }],
                tabIndex: 2,
                tabPosition:'left',
                relationmodeArray:[
                    {
                        title:'belongsto',
                    },
                    {
                        title:'hasone',
                    },
                    {
                        title:'hasmany',
                    }
                ],
            }
        },
        mounted() {
            this.generateSqlAll();
            this.query();
        },
        computed: {
            ...mapGetters(["permission"]),
        },
        methods: {
            closeShow(){
                this.showEdit=false
            },
            handleTabsEdit(targetName, action) {
                if (action === 'add') {
                    this.editFormList.list.push({
                        menu_title:'数据'+(parseInt(this.editFormList.list.length) +1),
                        relation: [],
                        pagemode: 1,
                    });
                }
                if (action === 'remove') {
                    let tabs = this.editFormList.list;
                    let activeName = this.editableTabsValue;
                    if (activeName === targetName) {
                        tabs.forEach((tab, index) => {
                            if (tab.menu_title === targetName) {
                                let nextTab = tabs[index + 1] || tabs[index - 1];
                                if (nextTab) {
                                    activeName = nextTab.menu_title;
                                }
                            }
                        });
                    }
                    this.editableTabsValue = activeName;
                    this.editFormList.list = tabs.filter(tab => tab.menu_title !== targetName);
                }
            },
            nameChange(e,index) {
                if(index === ''){
                    this.editForm.name = this.allSqlList[e].name;
                    this.editForm.comment = this.allSqlList[e].comment;
                }else{
                    this.editFormList.list[index].name = this.allSqlList[e].name;
                    this.editFormList.list[index].comment = this.allSqlList[e].comment;
                }
                this.loading = true;
                this.$http.post('/generate/generate/generateSqlColumn', {
                    table_name: this.allSqlList[e].name
                }).then(res => {
                    this.loading = false;
                    if (res.data.code === 0) {
                        this.relationprimarykeyArray = res.data.data
                        // this.menu_data = this.$util.toTreeData(res.data.data, 'id', 'pid');
                    } else {
                        this.$message.error(res.data.msg || '获取数据失败');
                    }
                }).catch(e => {
                    this.loading = false;
                    this.$message.error(e.message);
                });
            },
            /* 查询关联表字段*/
            relationChange(e,indexs) {
                let data = {
                    table_name:indexs===''?this.editForm.relation[e].relation:this.editFormList.list[indexs].relation[e].relation
                }
                this.loading = true;
                this.$http.post('/generate/generate/generateSqlColumn', data).then(res => {
                    this.loading = false;
                    if (res.data.code === 0) {
                        if(indexs===''){
                            this.editForm.relation[e].relationforeignkeyArray = res.data.data
                        }else{
                            this.editFormList.list[indexs].relation[e].relationforeignkeyArray = res.data.data
                        }
                        console.log(987)
                        // this.menu_data = this.$util.toTreeData(res.data.data, 'id', 'pid');
                    } else {
                        this.$message.error(res.data.msg || '获取数据失败');
                    }
                }).catch(e => {
                    this.loading = false;
                    this.$message.error(e.message);
                });
            },
            /* 查询菜单 */
            query() {
                this.loading = true;
                this.$http.get('/admin/AdminMenu/index').then(res => {
                    this.loading = false;
                    if (res.data.code === 0) {
                        this.menu_data = [];
                        var temp_menu = res.data.data;
                        for (var i = 0; i < temp_menu.length; i++) {
                            if (temp_menu[i].pid == 0) {
                                this.menu_data.push(temp_menu[i]);
                            }
                        }
                        // this.menu_data = this.$util.toTreeData(res.data.data, 'id', 'pid');
                    } else {
                        this.$message.error(res.data.msg || '获取数据失败');
                    }
                }).catch(e => {
                    this.loading = false;
                    this.$message.error(e.message);
                });
            },
            /* 删除追加关联表 */
            delRelation(index,indexs) {
                if(indexs ===''){
                    this.editForm.relation.splice(index, 1);
                }else{
                    this.editFormList.lsit[indexs].relation.splice(index, 1);
                }
            },
            /* *
             *追加关联表
             */
            addRelation(index) {
                var data = {}
                if(index === ''){
                    data = {
                        relation: '',
                        relationforeignkey: '', //关联外键
                        relationprimarykey: '', //关联主键
                        relationforeignkeyArray: [], //关联外键
                        relationfields: [
                        ], //关联显示字段
                        relationmode:'belongsto',
                    }
                    this.editForm.relation.push(data);
                }else{
                    data = {
                        relation: '',
                        relationforeignkey: '', //关联外键
                        relationprimarykey: '', //关联主键
                        relationforeignkeyArray: [], //关联外键
                        relationfields: [], //关联显示字段
                        relationmode:'belongsto',
                    }
                    this.editFormList.list[index].relation.push(data);
                }
            },

            /** 
             *  获取所有表及表内信息
             */
            generateSqlAll() {
                this.$http.post('/generate/generate/generateSqlAll', {}).then(res => {
                    if (res.data.code === 0) {
                        this.allSqlList = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 一键生成模块
             */
            generate() {
                /**
                 * 单模块生成
                 */
                let data = {};
                if(this.mode == 1){
                    data = this.editForm;
                    data.mode = this.mode;
                }else{
                    data.list = this.editFormList;
                    data.mode = this.mode;
                }
                const loading = this.$loading({lock: true});
                this.$http.post('/generate/generate/generate', this.editForm).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        });
                        this.$refs.table.reload();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },
        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
    .ikz-top-menu{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
